export default "__VITE_ASSET__F5TAUvRV__"